const KM = "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts";
const J3 = "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts";

// Order tuned so the 3 dark-background logos (Diamond, DB Knight, Major Life)
// are never adjacent on the white marquee.
const LOGOS = [
  { src: `${KM}/clmjh9g5_background_removed_image_0d8hVtkPTGakFH2ORr8FYA.png`, alt: "Knight Media Group", href: "#" },
  { src: `${KM}/t6ucrea9_IMG_8275.png`, alt: "Knight Insurance Solutions", href: "#" },
  { src: `${J3}/aswu75ne_FDE9FFDA-03BA-4D3A-80D8-DE134747CF2C.png`, alt: "Diamond in the Rough Foundation", href: "#" },
  { src: `${J3}/a1etgy7w_RapidCleanigtag2-JPG.jpeg`, alt: "Rapid Cleaning Services", href: "#" },
  { src: `${KM}/8sqrcsu2_IMG_9890.jpeg`, alt: "Major Moments Photography", href: "#" },
  { src: `${J3}/93zmmja3_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_30_38%20AM.png`, alt: "DB Knight Group", href: "#" },
  { src: `${KM}/hureplf0_0E8EAB18-DAF1-40B3-AA5A-4E69A45654DE.png`, alt: "AJ's Lawncare", href: "#" },
  { src: `${KM}/bp6r4s7u_02FC95C1-ED1F-4765-B6C0-E6A001DB016B.png`, alt: "Nikki's Next Level Hair & Beauty", href: "#" },
  { src: `${KM}/sk919zwo_A01B1AA9-657D-4CE3-B807-AE329135EBB0.png`, alt: "Major Life Insurance Group", href: "#" },
  { src: `${J3}/llpsbnih_tinywow_0F761CD9-6816-4E1B-9176-48F1EBDAA39E_91150651.png`, alt: "Knight Notary Services", href: "#" },
  { src: `${J3}/ujopc0r7_D571B052-7582-4161-A015-F11C42512B96.png`, alt: "Knight Credit Consultants", href: "#" },
  { src: `${J3}/zsnpa06a_C4A9A105-0FC0-43DD-971C-1D3B19AE6CBF.png`, alt: "Knight's Royal Rentals", href: "#" },
  { src: `${KM}/ybccnwlm_7A1DD6A7-937D-407E-8E83-87C46B6059C1.png`, alt: "G2 Globe", href: "#" },
  { src: `${J3}/xjmpou86_tinywow_FEE09309-5783-4D67-AD6C-EC8B3E91D93A_91075962.png`, alt: "Knight Asset Recovery", href: "#" },
  { src: `${KM}/als5dh4x_230FB8A3-0653-4764-A041-D034E188913E.png`, alt: "AJ's Lawncare (Original)", href: "#" },
  { src: `${J3}/3onmeggw_A3FA2E24-3CF4-4FB6-A7E6-9BC3F06D09B6.jpeg`, alt: "DJ Nip", href: "#" },
];

export default function LogoMarquee() {
  const items = [...LOGOS, ...LOGOS].map((logo, i) => ({
    ...logo,
    key: `${logo.alt}-${i}`,
  }));
  return (
    <section
      id="logos"
      className="relative bg-white border-y border-[#050B26]/10 overflow-hidden"
      data-testid="logo-marquee"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-2">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#1440E1] text-center font-semibold">
          Trusted by brands across Cincinnati &amp; beyond
        </p>
      </div>
      <div className="py-10 relative">
        <div className="marquee-track gap-12 sm:gap-16 px-8 items-center">
          {items.map((logo, i) => (
            <a
              key={logo.key}
              href={logo.href || "#"}
              target={logo.href && logo.href !== "#" ? "_blank" : undefined}
              rel={logo.href && logo.href !== "#" ? "noopener noreferrer" : undefined}
              aria-label={logo.alt}
              className="shrink-0 flex items-center justify-center h-24 sm:h-28 w-40 sm:w-48 p-2 transition-all duration-300 hover:scale-110 grayscale-0 opacity-90 hover:opacity-100 cursor-pointer"
              data-testid={`logo-item-${i}`}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                className="max-h-full max-w-full object-contain"
                style={{ filter: "drop-shadow(0 6px 18px rgba(5,11,38,0.18))" }}
              />
            </a>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
